import React, { PureComponent } from 'react';

export default class TaskStepView extends PureComponent {
  constructor(props) {
    super(props);
  }
}
TaskStepView.__interact__ = false;
TaskStepView.__result__ = false;

export class TaskStepInteractView extends TaskStepView {
  constructor(props) {
    super(props);
  }
}
TaskStepInteractView.__interact__ = true;

export class TaskStepResultView extends TaskStepInteractView {
  constructor(props) {
    super(props);
  }
}
TaskStepResultView.__result__ = true;
